import { render } from "./index.vue?vue&type=template&id=d4063ea8&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=d4063ea8&lang=less&scoped=true"

import exportComponent from "/Users/tolya/dev/ton/bridge/token-bridge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4063ea8"]])

export default __exports__